"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAmount = exports.serializeAmount = void 0;
const serializeAmount = (item) => {
    return typeof item.data.amount === "number" ? `${item.data.amount}` : "";
};
exports.serializeAmount = serializeAmount;
const validateAmount = (item) => {
    if (!item.required || item.data.amount > 0) {
        return { valid: true };
    }
    return { valid: false, error: { message: "Must be greater than 0." } };
};
exports.validateAmount = validateAmount;
//# sourceMappingURL=amount.js.map